import * as React from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import { ContestLeaderboard } from "../apis/contestApi";

export default function Leaderboard({
  leaderboard
}: {
  leaderboard?: ContestLeaderboard[];
}) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Rank</StyledTableCell>
            <StyledTableCell>User Info</StyledTableCell>
            <StyledTableCell>Total Votes</StyledTableCell>
            <StyledTableCell>Content</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leaderboard?.map((row, i) => {
            const contentLink = row.content_link;
            if (!contentLink) {
              return null;
            }
            return (
              <StyledTableRow key={row.activity_id}>
                <StyledTableCell component="th" scope="row">
                  {i + 1}
                </StyledTableCell>
                <StyledTableCell>
                  {row.user_info || row.user_id}
                </StyledTableCell>
                <StyledTableCell>{row.vote_count}</StyledTableCell>
                <StyledTableCell>
                  <PhotoProvider
                    photoClosable={false}
                    maskClosable={false}
                    pullClosable={true}
                    brokenElement={(p) => (
                      <Box
                        sx={{ color: "#fff" }}
                        display={"flex"}
                        flexDirection={"column"}
                        textAlign={"center"}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <video src={p.src} autoPlay loop muted playsInline />
                        <a href={p.src} target="_blank">
                          <small>Click to view if not loaded</small>
                        </a>
                      </Box>
                    )}
                  >
                    <Box
                      height="auto"
                      width="50px"
                      sx={{
                        position: "relative",
                        overflow: "hidden",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "& img, & video": {
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 2,
                          borderBottom: "none",
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0
                        }
                      }}
                    >
                      <PhotoView key={i} src={contentLink} overlay={i}>
                        {contentLink.includes(".mp4") ? (
                          <video
                            src={contentLink}
                            autoPlay
                            loop
                            muted
                            playsInline
                          />
                        ) : (
                          <img src={contentLink} alt={contentLink} />
                        )}
                      </PhotoView>
                    </Box>
                  </PhotoProvider>
                </StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#ffe263",
    color: "#000"
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    background: "#245c9c",
    color: "#fff"
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
